<template>
  <div class="flex flex-col divide-y">
    <div class="py-6 px-8">
      <span
        class="cursor-pointer flex flex-row items-center"
        @click="$router.push({ name: 'partners.new' })"
      >
        <span class="btn-plus mr-2"></span>
        <b class="text-15px leading-21px text-primary">Добавить реферрала</b>
      </span>
    </div>
    <Loading :loading="!list && waitPending">
      <PartnersTable
        :payload="partners"
        :busy="!list && waitPending"
        :row-style-class="() => 'cursor-pointer hover:bg-hint'"
        @on-row-click="onRowClick"
      />
    </Loading>
  </div>
</template>

<script type="text/jsx">
import { mapActions, mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import PartnersTable from '@/components/Partners/PartnersTable.vue';

export default {
  name: 'PartnersList',
  components: {
    PartnersTable,
    Loading,
  },
  methods: {
    ...mapActions({
      fetch: 'partners/ACT_FETCH_PARTNERS',
    }),
    onRowClick({ row, event }) {
      event.stopPropagation();
      this.$router.push({
        name: 'partners.edit',
        params: {
          id: row.id,
        },
      });
    },
  },
  computed: {
    ...mapState({
      list: (state) => state.partners.partners,
    }),
    partners() {
      return this.list ?? [];
    },
    waitPending() {
      return this.$wait.is('fetch.partners');
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
